import { e as _extends } from './_rollupPluginBabelHelpers-e71b1aad.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import { n as nodeOrStringProp } from './PropTypes-e1e509ba.js';
import 'moment';

function Select(props) {
  var name = props.name,
    label = props.label,
    className = props.className,
    onChange = props.onChange,
    required = props.required,
    showError = props.showError,
    extraContent = props.extraContent,
    errorMessage = props.errorMessage,
    options = props.options,
    reference = props.reference,
    disabled = props.disabled,
    labelHint = props.labelHint,
    qaData = props.qaData;
  var selectLabel = /*#__PURE__*/React__default.createElement("label", {
    htmlFor: name,
    className: "bf-form-element-label"
  }, label);
  var selectWrapperClasses = "bf-form-element-wrapper \n        ".concat(required ? 'bf-form-element-is-required' : '', " \n        ").concat(showError ? 'bf-form-element-has-error' : '', "\n        ").concat(className, " \n    ");
  return /*#__PURE__*/React__default.createElement("div", {
    className: selectWrapperClasses
  }, label ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-form-element-label-wrapper"
  }, labelHint ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, selectLabel, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-form-element-label-hint"
  }, labelHint)) : selectLabel) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-select-wrapper"
  }, /*#__PURE__*/React__default.createElement("select", _extends({
    name: name,
    ref: reference,
    onChange: onChange,
    className: "bf-form-element ".concat(showError && 'bf-form-element-has-error'),
    required: required,
    disabled: disabled
  }, qaData), options.map(function (option, index) {
    var key = "OPTION_".concat(index);
    return /*#__PURE__*/React__default.createElement("option", {
      value: option.value,
      key: key,
      selected: option.selected
    }, option.content);
  }))), showError && errorMessage ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-form-element-error-message"
  }, errorMessage) : null, extraContent ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-form-element-extra-content"
  }, extraContent) : null);
}
Select.defaultProps = {
  className: '',
  label: '',
  labelHint: '',
  name: '',
  onChange: function onChange() {},
  required: false,
  extraContent: '',
  disabled: false,
  reference: null,
  qaData: {},
  showError: false,
  errorMessage: ''
};
Select.propTypes = {
  /**
  Custom className
   */
  className: PropTypes.string,
  /**
  Input label
   */
  label: nodeOrStringProp,
  /**
  Input hint
   */
  labelHint: nodeOrStringProp,
  /**
  Input name
   */
  name: PropTypes.string,
  /**
  Input name
   */
  onChange: PropTypes.func,
  /**
  Required Input
   */
  required: PropTypes.bool,
  /**
  Element render after Input
   */
  extraContent: nodeOrStringProp,
  /**
  Input disabled
   */
  disabled: PropTypes.bool,
  /**
  Input ref
   */
  reference: PropTypes.shape({}),
  qaData: PropTypes.shape({}),
  /**
  Show Input with error status
   */
  showError: PropTypes.bool,
  /**
  Error message on error status
   */
  errorMessage: nodeOrStringProp,
  /**
  Select options
   */
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    selected: PropTypes.bool
  })).isRequired
};

export default Select;
//# sourceMappingURL=Select.js.map
